var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBinance = function SvgBinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F3BA2F",
    clipPath: "url(#binance_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.893 6.724 8 3.616l3.109 3.11 1.808-1.809L8 0 3.085 4.916zM0 8l1.808-1.808L3.616 8 1.808 9.808zm4.893 1.277L8 12.384l3.109-3.108 1.809 1.807h-.001L8 16l-4.915-4.915-.003-.002zm7.491-1.276 1.808-1.808L16 8.001 14.192 9.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.833 8h.001L8 6.165 6.644 7.521l-.156.155-.321.322L6.164 8l.003.003L8 9.836l1.834-1.834L9.835 8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "binance_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgBinance;